<template>
  <div
    class="modal"
    v-if="openInformationPopup === true"
    :class="{ visible: openInformationPopup }"
  >
    <div
      class="frame visible"
      style="background-image: url('https://storage.googleapis.com/wwf-australia-prod.appspot.com/website-public-assets/4669/dist/assets/img/forest-background.png')"
    >
      <div class="close" @click="closeModal">
        <i class="fa far fa-times"></i>
      </div>
      <div class="content">
        <h4>{{ popupTitle }}</h4>
        <!-- <p>{{popupDescription}}</p> -->
        <div v-html="popupDescription" class="popupDescription"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["openInformationPopup", "popupTitle", "popupDescription"]),
  },
  methods: {
    closeModal() {
      this.$store.commit("updateOpenInformationPopup", false);
      
      // Log close popup
      this.$store.dispatch("logSimpleEvent", {
        eventName: "Click (x) to close",
        eventProperties: { "Close": this.popupTitle },
      });
    },
  },
};
</script>

<style scoped>
.modal {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 15%;
  left: 30%;
  width: 43%;
  z-index: 100;
}

.modal.visible {
  display: flex;
}

.modal .frame {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  height: 320px;
  width: 100%;
  max-width: 600px;
  padding: calc(4 * var(--space));
  background-size: 100% 100%;
  background-color: #1c3226;
  background-repeat: no-repeat;
}

.modal .frame .close {
  position: absolute;
  top: calc(1.5 * var(--space));
  right: calc(2 * var(--space));
  cursor: pointer;
}

.modal .frame.visible {
  display: flex;
}

.modal .frame h2,
.modal .frame p,
.modal .frame i {
  color: var(--white);
  margin: 0;
  text-align: center;
}

h4 {
  text-transform: uppercase;
}

.modal .frame .content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 12px;
}

.modal .frame h4 {
  font-size: 24px;
}

.modal .frame p {
  font-size: 16px;
  line-height: 140%;
  text-align: center;
}

.popupDescription {
  margin: 0;
  color: white;
  text-align: center;  
}

h4,
p {
  margin: 0;
  color: white;
  text-align: center;
}

@media screen and (max-width: 1150px) {
  .modal {
    left: 30%;
    width: 50%;
  }
}

@media screen and (max-width: 950px) {
  .modal {
    left: 25%;
    width: 55%;
  }
}

@media screen and (max-width: 860px) {
  .modal {
    top: 10%;
    left: 20%;
    width: 60%;
  }
}

@media screen and (max-width: 800px) {
  .modal {
    left: 15%;
    width: 75%;
  }

  .modal .frame {
    height: 280px;
  }
}

@media screen and (max-width: 650px) {
  .modal {
    left: 8%;
    width: 85%;
  }
}

@media screen and (max-width: 550px) {
  .modal .frame {
    height: 60%;
  }
}

/* Style from elcom */
h4 {
  font-family: 'Lato',sans-serif;
  font-weight: 600;
  font-size: 26;
}

.popupDescription >>> a {
  color: #f37043;
}
/* END */
</style>


// WEBPACK FOOTER //
// InformationPopup.vue?3e36b857